var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DModels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8746 54.563L13.7266 68.6964L33.5679 80.5514V65.8601L13.8746 54.563Z",
    fill: "#DB6C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1462 68.5342L38.9985 82.6676L58.8391 94.5224V79.832L39.1462 68.5342Z",
    fill: "#DB6C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1462 90.5918L38.9985 104.725L58.8391 116.208V101.517L39.1462 90.5918Z",
    fill: "#DB6C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8746 75.5254L13.7266 89.6589L33.5679 101.514V86.8233L13.8746 75.5254Z",
    fill: "#DB6C2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1709 13.104L119.853 44.8204V68.7714L139.922 80.6376V104.643L65.1709 61.1701V13.104Z",
    fill: "#E9AF34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140 104.749L65.2378 61.2031L52.7178 68.9884",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.974 44.7144L64.9881 13L10.0005 44.7663L64.9881 76.3128L119.974 44.7144Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 100.554L120.225 68.9556",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.975 68.916L64.9883 37.2017L31.6685 57.2256",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2505 92.9688L85.0133 136.346L140.001 104.748",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 13.1997V61.2022",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 76.313V100.445",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.974 44.7661V68.8983",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.225 68.9556L140 80.6322",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140 104.748V80.6323",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0049 136.47V112.355",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2373 100.554L85.0046 112.354",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140 80.6323L85.0049 112.354",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10 68.3184L10.2498 92.9685",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10 44.7661V68.8983",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DModels);
export default __webpack_public_path__ + "static/media/3d_models.5bdeaafd3270f6c72246a7a12b44101f.svg";
export { ForwardRef as ReactComponent };